module.exports = __webpack_public_path__ + "components/media-kit/static/icon-setup-bcba0118c1d4f21568af8d072e94cbe9.svg";